export default __webpack_public_path__ + "static/media/laptop.723f273b.svg";